// @flow
import ModelPicker from './js/lib/ModelPicker.js';
import SketchfabWrapper from './js/lib/SketchfabWrapper.js';
import Camera from './js/lib/Camera.js';
import type {Config} from './js/Config';

class App {
    config: Config;
    activeLevel: number;
    sketchfabwrapper: null;

    getLevelCount():number {
        return this.config.levels.length;
    }

    loadConfig(url:string):Promise<any> {
        return fetch(url)
            .then((response) => response.json())
            .then((config:Config) => {
                this.config = config;

                // @todo Hack to expose config to ModelPicker and Camera
                window.jsonData = this.config;
            });
    }

    init() {
        this.setProjectTitle(this.config.title);

        let logoEl:HTMLImageElement = document.getElementById('project-logo');
        if (this.config.logo && this.config.logo !== '') {
            logoEl.src = "./img/logos/" + this.config.logo;
        } else {
            (logoEl.parentNode).removeChild(logoEl);
        }

        let panoLoadingEl:HTMLImageElement = document.getElementById('panorama-loading');
        if (this.config.pleasewait && this.config.pleasewait !== '') {
            panoLoadingEl.src = "./img/" + this.config.pleasewait;
        } else {
            (panoLoadingEl.parentNode).removeChild(panoLoadingEl);
        }

        document.getElementById('level-up').addEventListener('touchend', (e) => this.onLevelUp(e));
        document.getElementById('level-down').addEventListener('touchend', (e) => this.onLevelDown(e));
        document.getElementById('level-up').addEventListener('click', (e) => this.onLevelUp(e));
        document.getElementById('level-down').addEventListener('click', (e) => this.onLevelDown(e));
        document.getElementById('panorama-close').addEventListener('touchend', (e) => this.onExitPanorama(e));
        document.getElementById('panorama-close').addEventListener('click', (e) => this.onExitPanorama(e));
        document.getElementById('fullscreen').addEventListener('touchend', (e) => this.toggleFullscreen(e));
        document.getElementById('fullscreen').addEventListener('click', (e) => this.toggleFullscreen(e));

        if (!document.documentElement.requestFullscreen || !document.fullscreenEnabled) {
            // Device does not support fullscreen
            document.getElementById('fullscreen').classList.add('hide');
        }

        this.initSketchFab(this.config.sketchfabID);
    }

    toggleFullscreen(e:Event) {
        e.preventDefault();

        if (!document.documentElement.requestFullscreen) {
            return;
        }

        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen();
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    }

    initSketchFab(id) {
        let client = new Sketchfab('1.3.0', document.getElementById("api-frame"));
        this.sketchfabwrapper = SketchfabWrapper;
        client.init(id, {
            success: (api) => {
                // @todo Hack to expose Sketchfab API to ModelPicker and Camera
                SketchfabWrapper.api = api;

                document.body.classList.remove("loading");

                api.addEventListener("viewerready", () => {
                    //Initialize the nodemap
                    SketchfabWrapper.getSceneGraph();
                    
                    //get the textures list
                    SketchfabWrapper.getTextureList();
                    
                    //get the animations list
                    SketchfabWrapper.setAnimation(0);
                    
                    //Hide the big sphere we'll project the panos on
                    SketchfabWrapper.SetObjectVisibility(this.config.panoobject,false,true)
                    
                    // Start at the top level
                    this.setLevel(this.getLevelCount() -1);

                    // document.body.classList.remove("loading");
                    document.body.classList.remove("hide-level-controls");

                    //Set the camera
                    SketchfabWrapper.SetView(this.config.views['start'].eye, this.config.views['start'].lookat, 1);

                    //add the event when objects are clicked
                    SketchfabWrapper.api.addEventListener( 'click', ModelPicker.ClickCallback, { pick: 'fast' })
                    Camera.cameraLoopOrbit();
                });

                api.load(function(){
                    api.start();
                });
            },

            error: function onError(e) {
                console.log("Viewer error", e);
            },

            autospin: 0.0,
            transparent: 0,
            camera: 1,
            // blending: 0,
            ui_stop: 0,
            ui_infos: 0,
            ui_controls: 0,
            ui_watermark: 1,
            scrollwheel: 1
        });
    }

    setLevel(level:number) {
        this.activeLevel = Math.max(0, Math.min(this.getLevelCount() -1, level));

        // Update Sketchfab model
        for (let i = 0; i <= this.getLevelCount() -1; i++) {
            SketchfabWrapper.SetObjectVisibility(this.config.levels[i]['3dname'], i <= this.activeLevel, true);
        }

        // Update UI
        let levelNameEl = document.getElementById('level-name');
        if (levelNameEl) {
            levelNameEl.textContent = this.config.levels[this.activeLevel].name;
        }

        let levelUpEl = document.getElementById('level-up');
        levelUpEl.classList.toggle('disabled', this.activeLevel === this.getLevelCount() -1);

        let levelDownEl = document.getElementById('level-down');
        levelDownEl.classList.toggle('disabled', this.activeLevel === 0);
    }

    setProjectTitle(title:string) {
        let titleEl = document.getElementById('project-title');
        if (titleEl) {
            titleEl.textContent = title;
        }

        document.title = title;
    }

    onLevelUp(e:Event) {
        e.preventDefault();

        this.setLevel(this.activeLevel + 1)
    }

    onLevelDown(e:Event) {
        e.preventDefault();

        this.setLevel(this.activeLevel - 1)
    }

    onPanoramaLoadStart() {
        document.body.classList.add('loading-panorama');
    }

    onPanoramaLoadEnd() {
        document.body.classList.remove('loading-panorama');
    }

    onEnterPanorama() {
        document.body.classList.add('in-panorama');
    }

    onExitPanorama(e:Event) {
        e.preventDefault();

        document.body.classList.remove('in-panorama');

        ModelPicker.ExitPanoMode();
        ModelPicker.EnterOrbitMode();

    }

}

export default App;




// WEBPACK FOOTER //
// ./src/App.js